import { PersonResponse } from "../../../types";
import { useQuery } from "@tanstack/react-query";
import { getPersonApi } from "../../../api/resources.api";

export function useSinglePerson(id: number) {
  return useQuery<PersonResponse, Error>({
    queryKey: ["person", id],

    enabled: !!id,

    queryFn: async () => {
      const response = await getPersonApi({ id });

      if (!response?.status) {
        throw new Error("Invalid Person response");
      }

      const data = Array.isArray(response.data)
        ? response.data[0]
        : response.data;

      return {
        ...response,
        data: {
          ...data,
          logo:
            typeof data.logo === "string"
              ? data.logo.replace(/\\/g, "")
              : data.logo,
        },
      };
    },

    staleTime: 1000 * 60 * 5,
  });
}
